<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-06 18:27:02
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-30 10:18:56
-->
<template>
  <v-card class="bigbox">
    <mrc_ess_iconGroup
      :showReturn="false"
      v-if="$route.name == 'internationIndex'"
      :show_del="false"
      :showEdit="false"
    >
      <v-btn
        class="white--text"
        fab
        depressed
        v-if="hasBtn('add-version-management')"
        small
        @click="handleAdd"
        color="primary"
      >
        <v-icon class="material-icons">add</v-icon>
      </v-btn>
    </mrc_ess_iconGroup>
    <v-card-text v-if="$route.name == 'internationIndex'">
      <div class="text-body-s text--secondary" style="padding-left: 37px">
        {{ $t("label_The_product_name") }}
      </div>
      <v-treeview
        selected-color="primary"
        class="mt-4"
        expand-icon="arrow_drop_down"
        v-for="(item, index) in desserts"
        :key="index"
        item-children="clientType"
        style="border: 1px solid #e8e8e8; border-radius: 4px"
        :items="[item]"
      >
        <template v-slot:label="{ item }">
          <span v-if="INT(item.product_title)">
            {{ INT(item.product_title) }}
          </span>
          <span v-if="INT(item.client_type_label)">
            <mrc_ess_svgIcon
              :iconClass="item.client_type ? item.client_type : ''"
              style="font-size: 23px"
            />
            <span class="black--text ml-2">
              {{ INT(item.client_type_label) }}
            </span>
          </span>
        </template>
        <template v-slot:append="{ item }">
          <div v-if="INT(item.client_type_label)" class="rowbox">
            <v-btn
              rounded
              v-for="(item1, index) in splitINT(item.version)"
              color="primary"
              depressed
              small
              :key="index"
              @click="detailVersion(item, index)"
              class="ma-1"
            >
              {{ item1 }}
            </v-btn>
          </div>
        </template>
      </v-treeview>
    </v-card-text>
    <router-view v-else></router-view>
  </v-card>
</template>

<script>
import { getLabelList } from "@/service/api/internationalization";
export default {
  components: {},
  props: {},
  data() {
    return {
      expanded: [],
      loading: false,
      desserts: [],
      // options: {
      //   pagesize: 5,//条数
      //   cpage: this.$store.state.cpage,  //页数
      //   totalcount: null, //总条数
      //   totalpage: null, //总页数
      // },
    };
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  beforeDestroy() {},
  async created() {
    await this.getBtnPermissionList();
  },
  async mounted() {
    await this.getlist();
  },
  methods: {
    // rowgodetail (item) {
    //   // console.log(item);
    //   this.$store.commit('set_iconstatus', true)  //行内进图标显示
    //   this.$store.commit('set_uuid', item.uuid)  //
    //   this.$store.commit('set_subPage_name', item.language_master_key)  //
    //   this.$router.push({
    //     name: 'detailverifymessagemanagement',
    //     params: { title: item.language_master_key },
    //   })
    // },
    // handleClick ({ index }, item) {
    //   switch (index) {
    //     case 0:
    //       this.$store.commit('set_iconstatus', false)  //行内进图标显示
    //       this.$store.commit('set_uuid', item.uuid)  //
    //       this.$store.commit('set_subPage_name', item.language_master_key)  //
    //       this.$router.push({
    //         name: 'detailverifymessagemanagement',
    //         params: { title: item.language_master_key }
    //       })
    //       break
    //     case 1:
    //       this.$myConfirm({
    //         content:this.$t('message_Confirm_the_deletion')
    //       }).then(res => {
    //         deletehint({
    //           uuid: item.uuid
    //         }).then(res => {
    //           if (res.code == 200) {
    //             this.$Message({ text: this.$t('message_The_deletion_was_successful') })
    //             this.getlist()
    //           }
    //         })
    //       }).catch(err => { })
    //       break
    //   }
    // },
    detailClient(item) {
      this.$store.commit("set_version", ""); //版本号
      this.$store.commit("set_version_uuid", ""); //版本号 uuid
      this.$store.commit("set_client_type", item.client_type); //客户端类型
      this.$router.push({
        name: "allClientMsg",
      });
    },
    detailVersion(item, index) {
      this.$store.commit("set_version", item.version[index]); //版本号名称
      this.$store.commit("set_version_uuid", item.uuids.split(",")[index]); //版本号 uuid
      this.$store.commit("set_client_type", item.client_type); //客户端类型
      this.$router.push({
        name: "allClientMsg",
      });
    },
    handleAdd(item) {
      this.$store.commit("set_version", ""); //版本号
      this.$store.commit("set_uuid", ""); //版本号
      this.$store.commit("set_version_uuid", ""); //版本号 uuid
      // this.$store.commit('set_client_type', item.client_type) //客户端类型
      this.$router.push({
        name: "addVersion",
        params: {
          type: "internation",
        },
      });
    },
    async getlist(obj) {
      this.loading = true;
      if (this.desserts.length == 1 && this.options.cpage != 1)
        this.options.cpage--;
      // if (obj) {
      //   const { cpage, pagesize } = obj
      //   this.options = obj
      // }
      const res = await getLabelList();
      // {
      //   cpage: this.options.cpage,
      //   pagesize: this.options.pagesize
      // }
      if (res.code == 200) {
        res.data.map((item) => {
          if (item.version) {
            item.version =
              item.version.indexOf(",") != -1
                ? item.version.split(",")
                : [item.version];
          } else {
            item.version = [];
          }
          item.version.sort((a, b) => {
            return b - a;
          });
        });
        this.desserts = res.data;
        // console.log(this.desserts);
        // this.options.totalcount = res.totalcount
        // this.options.totalpage = res.totalpage
      }
      this.loading = false;
    },
  },
  computed: {
    childrenheaders() {
      return [
        {
          text: this.$t("label_Application_platform"),
          align: "start",
          sortable: false,
          value: "client_type",
        },
        {
          text: this.$t("label_version"),
          align: "start",
          sortable: false,
          value: "versionArr",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
        },
      ];
    },
    menulist() {
      return [
        { name: this.$t("label_Edit"), show: true, type: "edit" },
        { name: this.$t("label_delete"), show: true, type: "del" },
      ];
    },
    Parentheaders() {
      return [
        {
          text: this.$t("label_The_product_name"),
          align: "start",
          sortable: false,
          value: "product_title",
        },
        { text: "", value: "data-table-expand" },
      ];
    },
  },
  watch: {
    $route(v) {
      if (v.name == "internationIndex") {
        this.getlist();
      }
    },
  },
};
</script>

<style scoped>
/* .bigbox /deep/.addBtn {
  position: static;
  top: 0px;
  right: 0px;
} */
.rowbox {
  padding: 8px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 50vw;
}
/deep/ .v-data-table {
  padding: 0 0 !important;
}
</style>
